import { render, staticRenderFns } from "./ZoneReviewControl.vue?vue&type=template&id=61fae845&scoped=true"
import script from "./ZoneReviewControl.vue?vue&type=script&lang=js"
export * from "./ZoneReviewControl.vue?vue&type=script&lang=js"
import style0 from "./ZoneReviewControl.vue?vue&type=style&index=0&id=61fae845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fae845",
  null
  
)

export default component.exports